// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HGcHZbE0gKfRR7Ad9X0z{height:100%;display:flex;flex-direction:column}.k9hQOeDCjqvrBjct02uo{width:100%;max-height:100%}`, "",{"version":3,"sources":["webpack://./src/components/Lookup/lookup.module.scss"],"names":[],"mappings":"AAAA,sBACI,WAAA,CACA,YAAA,CACA,qBAAA,CAEA,sBACI,UAAA,CACA,eAAA","sourcesContent":[".lookup {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n\n    &__section {\n        width: 100%;\n        max-height: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lookup": `HGcHZbE0gKfRR7Ad9X0z`,
	"lookup__section": `k9hQOeDCjqvrBjct02uo`
};
export default ___CSS_LOADER_EXPORT___;
